import category from "@/http/requests/category"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      category.fetch(queryData).then(response => {
        commit('SET_CATEGORIES', response.data.data.categories)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      category.add(data).then(response => {
        commit('ADD_CATEGORY', response.data.data.createCategory)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      category.update(data).then(response => {
        commit('UPDATE_CATEGORY', response.data.data.updateCategory)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      category.delete(categoryId).then(response => {
        commit('DELETE_CATEGORY', categoryId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      category.infos(categoryId).then(response => {
        commit('ADD_CATEGORY_INFOS', response.data.data.categoryInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
